<mat-accordion>
  <mat-expansion-panel hideToggle>
    <mat-expansion-panel-header>
      <mat-panel-title>Preview Settings</mat-panel-title>
      <mat-panel-description>See how this page renders for users</mat-panel-description>
    </mat-expansion-panel-header>

    <div class="overrides">
      @for (variable of getOverriddenVariables(); track variable.name) {
        <div class="override">
          <div class="variable-name">
            {{variable.label}}:
          </div>
          <div class="value">
            <tyt-condition-value-editor [type]="variable.type" [enumOptions]="variable.enumOptions"
              [value]="getValue(variable.name)"
              (valueChange)="overrideValue(variable.name, $event)"
              />
          </div>
          <div class="status">
            @if (isOverridden(variable.name)) {
              <button mat-icon-button (click)="resetOverride(variable.name)">
                <mat-icon>close</mat-icon>
              </button>
            }
          </div>
        </div>
      } @empty {
        You can preview this page by overriding specific variables that might be used within Conditional blocks
        on this page. To get started, click Override below.
      }
    </div>

    <mat-menu #overridableVariablesMenu>
      @for (variable of variables; track variable.name) {
        @if (!isOverridden(variable.name)) {
          <button mat-menu-item (click)="overrideValue(variable.name, getValue(variable.name))">
            {{ variable.label }}
          </button>
        }
      }
    </mat-menu>

    <br/>
    <button mat-raised-button color="primary" [matMenuTriggerFor]="overridableVariablesMenu">
      <mat-icon>add</mat-icon>
      Override
    </button>
  </mat-expansion-panel>
</mat-accordion>
